export default "__VITE_ASSET__BZvrCPgg__"